import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggingService } from '../../../../../../modules/src/lib/core/services/logging.service';
import { AlertContextEnum } from '../../../../../../modules/src/lib/core/enums/alert-context.enum';
import { DateUtils } from '../../../../../../modules/src/lib/core/utils/date.utils';
import { EmployeeModel } from '../../../../../../../../common/dist/angular/models/employee.model';
import { EmployeeApiController } from '../../../api-controllers/employee.api-controller';
import { EmployeeRoleEnum } from '../../../../../../../../common/src/enums/employee-role.enum';
import { EmployeeUtils } from '../../../utils/employee.utils';
import { EmployeeStatusEnum } from '../../../../../../../../common/dist/angular/enums/employee-status.enum';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss'],
  standalone: false,
})
export class EmployeeListComponent implements OnInit {
  alertContextEnum = AlertContextEnum;

  isLoading = true;
  showHasBeenRefreshed = true;

  employees: EmployeeModel[];
  statusEnum = EmployeeStatusEnum;

  constructor(private readonly employeeApiController: EmployeeApiController,
              private readonly dateUtils: DateUtils,
              private readonly router: Router,
              private readonly loggingService: LoggingService,
              private readonly route: ActivatedRoute) {
  }

  ngOnDestroy(): void {
  }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  async refresh(): Promise<void> {
    this.isLoading = true;
    this.showHasBeenRefreshed = false;

    this.employees = await this.employeeApiController.listForOrganization();
    // for (const clientQuestionnaire of this.clientQuestionnaires) {
    //   await this.clientQuestionnaireStore.save(clientQuestionnaire.id, clientQuestionnaire);
    // }

    this.isLoading = false;
    this.showHasBeenRefreshed = true;

    setTimeout(() => {
      this.showHasBeenRefreshed = false;
    }, 3000);
  }

  getRole(employeeRole: EmployeeRoleEnum): string {
    return EmployeeUtils.getEmployeeRole(employeeRole);
  }

  getStatusText(status: EmployeeStatusEnum): string {
    return EmployeeUtils.getEmployeeStatusText(status);
  }
}
